import type INodeSetting from "./node-setting";

class ScenarioDeviceGroupNodeSetting implements INodeSetting{
  groupSeq?: number;
  constructor() {    
  }
}

export default ScenarioDeviceGroupNodeSetting;